import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Card, Btn, Input } from "@/components/erp/ui";
import { X } from "lucide-react";

// Pilih merek mesin dari daftar yang diatur admin utama di Settings
export const BrandSelect = ({ value, onChange, testid = "brand-select" }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/machine-brands").then(({ data }) => setList(data)).catch(() => {}); }, []);
  const opts = value && !list.includes(value) ? [value, ...list] : list;
  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className="w-full h-10 border border-slate-300 rounded-lg px-2 text-sm bg-white">
      <option value="">— pilih merek —</option>{opts.map((b) => <option key={b} value={b}>{b}</option>)}
    </select>
  );
};

export const BrandSettings = () => {
  const [list, setList] = useState(null); const [nb, setNb] = useState("");
  useEffect(() => { api.get("/machine-brands").then(({ data }) => setList(data)).catch(() => {}); }, []);
  if (!list) return null;
  const save = async (v) => { try { const { data } = await api.put("/machine-brands", { brands: v }); setList(data); toast.success("Daftar merek disimpan"); } catch (e) { const dt = e?.response?.data?.detail; toast.error(typeof dt === "string" ? dt : "Gagal menyimpan"); } };
  return (
    <Card className="p-4 mt-4" data-testid="brand-settings">
      <h3 className="font-semibold text-sm mb-2">Merek mesin</h3>
      <div className="flex flex-wrap gap-1.5 mb-2">{list.map((b) => <span key={b} className="text-xs px-2 py-0.5 rounded-full bg-slate-100 inline-flex items-center gap-1" data-testid={`brand-${b}`}>{b}<button type="button" data-testid={`brand-del-${b}`} onClick={() => save(list.filter((x) => x !== b))}><X className="w-3 h-3" /></button></span>)}</div>
      <div className="flex gap-2"><Input data-testid="brand-new" placeholder="Merek baru" value={nb} onChange={(e) => setNb(e.target.value)} className="!w-56" /><Btn variant="ghost" data-testid="brand-add" disabled={!nb.trim()} onClick={() => { save([...list, nb.trim()]); setNb(""); }}>Tambah merek</Btn></div>
    </Card>
  );
};
